import type { HelpFile } from '../../types/help'
import { CertificationCampaignsTestIds } from '../../../testids/CertificationCampaignsTestIds'

export const certificationCampaignsHelp: HelpFile = {
  docPage: '/docs/governance/certification-campaigns',
  texts: {
    [CertificationCampaignsTestIds.certificationCampaignsList]:
      'Aktive und abgeschlossene Zertifizierungskampagnen — Prüfer attestieren Zugriffszuweisungen innerhalb der festgelegten Frist.',
    [CertificationCampaignsTestIds.colPolicy]: 'Zertifizierungsrichtlinie, aus der diese Kampagne entstanden ist — legt Umfang, Frequenz und Prüfverhalten fest.',
    [CertificationCampaignsTestIds.campaignComboboxPolicy]:
      'Zertifizierungsrichtlinie, auf der diese Kampagne basiert — ihr Umfang, Prüfertyp und ihre Frequenz steuern die Erzeugung der Prüfeinträge. Erforderlich.',
  },
}
